<template>

  <v-container fill-height>
    <v-layout justify-center>
      <v-flex
        mb-10
        xs12
        sm6
        md6
      >
        <div class="text-xs-center">
          <img :src='webconfig.webconfig.loginLogo' />
        </div>
        <v-card class="elevation-12 mt-3">

          <v-card-text>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-text-field
                prepend-icon="person"
                name="email"
                label="Email"
                type="email"
                v-model="email"
                :rules="emailRules"
                required
              >
              </v-text-field>
              <v-text-field
                prepend-icon="lock"
                name="password"
                label="Password"
                id="password"
                type="password"
                required
                v-model="password"
                :rules="passwordRules"
              >
              </v-text-field>
              <v-btn
                block
                color="primary"
                :disabled="!valid"
                @click="submit"
              >Login</v-btn>

            </v-form>
          </v-card-text>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
const fb = require('../firebaseConfig.js')
import { mapFields } from 'vuex-map-fields';
import router from '@/router';
import config from "../firebaseIDs";
export default {

  name: 'Signin',
  created () {
    fb.auth.signOut().then(() => {
      this.user = null
      this.isAuthenticated = false
      this.$router.push('/')

    });
    if (this.user !== null) {
      router.push('/home');
    }
  },

  data () {
    return {
      webconfig: config,
      error: "error",
      valid: false,
      email: '',
      password: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v =>
          v.length >= 6 ||
          'Password must be greater than 6 characters'
      ]
    };
  },
  mounted () {
  },
  computed: {
    ...mapFields([
      'isAuthenticated',
      'user',
      "snackBarMessage",
      "snackBar",
      "snackBarcolor"
    ])  },
  methods: {
    submit () {
      if (this.$refs.form.validate()) {
        fb.auth
          .signInWithEmailAndPassword(this.email, this.password)
          .then(user => {
            this.user = user
            this.isAuthenticated = true
            router.push('/home');
          })
          .catch((error) => {
            this.snackBar = true
            this.snackBarMessage = error.message
            this.snackBarcolor = "warning"
            this.user = null
            this.isAuthenticated = false
            router.push('/');
          });
      }
    }
  },
}
</script>

<style scoped>
</style>